export default __webpack_public_path__ + "static/media/prev-GNSS-Receiver-4.65ad8b13.png";